export default function HtmlContent({ html, className = '' }) {
    const safeHtml = typeof html === 'string' ? html : '';
    const decodedHtml = safeHtml
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&amp;/g, '&')
        .replace(/&nbsp;/g, ' ');

    const effectiveClassName = ['richtext', className].filter(Boolean).join(' ');

    return <div className={effectiveClassName} dangerouslySetInnerHTML={{ __html: decodedHtml }} />;
}
